import axios from 'axios';
import { defaultAuthState } from '../../../shared/appLocalStorage';
import { apiBaseUrl } from '../../../shared/links';
import { signInInput } from './signInInput';
import { signInOutput } from './signInOutput';

export const signIn = async (input: signInInput) => {
  const url = `${apiBaseUrl}/api/user/signin`;
  try {
    const response = await axios.post<signInOutput>(url, input);
    return response.data;
  } catch (err: any) {
    const retError: signInOutput = {
      ...defaultAuthState,
      errorMessage: err
    };
    return err.response &&
      err.response.data ?
      err.response.data as signInOutput : retError;
  }
};
